import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";
import { useIsECAUIEnabled } from "../hooks/useCanViewStudio2";

const oldToggleName = "ENABLE_HEY_CERTA";
const newToggleName = "DISABLE_DESIGNAI";

export const useDesignAIEnabled = (): boolean => {
  const { data: config } = useInstanceConfigQuery();
  const specialFeatures = config?.custom_ui_labels.specialFeatures;

  const isECAUIEnabled = useIsECAUIEnabled();

  return (
    Array.isArray(specialFeatures) &&
    (specialFeatures.includes(oldToggleName) ||
      (!specialFeatures.includes(newToggleName) && isECAUIEnabled))
  );
};
